import { CellClickedEvent, ColDef } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { DocumentService } from '../../services/document.service';
import { ProjectsService } from '../../services/projects.service';

@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrl: './search-page.component.scss'
})
export class SearchPageComponent {
  term: string = '';
  documents: any = [];
  projects: any = [];
  selectedProject: any = null;
  projectId: any;
  documentId: any;
  documentName: string = '';
  colDefs: ColDef[] = [
    { field: "originalFileName", headerName: "File Name" },
    { field: "location", headerName: "Source Location"},
    { field: "currentWorkflowStepName", headerName: "Current Workflow Step" },
    { field: "assignedUserName", headerName: "Assigned User" }
  ];  
  documentGridOptions = {
    defaultColDef: {
      resizable: true,
      sortable: true
    },
    onCellClicked: this.onCellClicked.bind(this),
    paginationPageSize: 15,
    paginationPageSizeSelector: [15, 30, 45, 60]
  };
  constructor(private readonly projectsService: ProjectsService, private readonly documentService: DocumentService) {
    this.projectsService.getProjectsOnce(true).subscribe(_ => {
      this.projects = _;
    });
  }
  search() {
    if (this.selectedProject == null) { return; }
    this.documentService.search(this.selectedProject.id, this.term).subscribe(_ => this.documents = _);
  }
  view(projectId: string, documentId: string, documentName: string) {
    this.projectId = projectId;
    this.documentId = documentId;
    this.documentName = documentName;
  }
  private onCellClicked(event: CellClickedEvent) {
    const selectedProjectId = event.data['projectId'];
    const selectedDocumentId = event.data['id'];
    const selectedDocumentName = event.data['originalFileName'];
    this.view(selectedProjectId, selectedDocumentId, selectedDocumentName);
  }
}
